import React, { useMemo, useEffect, useCallback, useState } from 'react';

import {
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@material-ui/core';

import Pagination from '@material-ui/lab/Pagination';

import { Search } from './components';

import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { isNull, isArray, concat, isEmpty, find, includes } from 'lodash';

import * as S from './styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onCallback,
  onCallbackRemover,
  onCallabackEditar,
  clearSelecteds,
  onCallbackNewPage,
  paginate,
  showCount,
  search,
}) {

  const [active, setActive] = useState({});
  const [selecteds, setSelected] = useState([]);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState({});


  const totalPages = useMemo(
    () =>
      Math.ceil(
        data.filter((item) =>
          !isEmpty(query)
            ? item[query.column].toString().toUpperCase().indexOf(query.text.toString().toUpperCase()) >
            -1
            : true
        ).length / paginate
      ),
    [data, paginate, query]
  );

  const countPage = useMemo(() => Number(page * paginate - paginate), [
    data,
    page,
    paginate,
  ]);

  const delimiter = useMemo(() => Number(countPage + paginate), [
    data,
    countPage,
    paginate,
  ]);

  useEffect(() => {
    if (clearSelecteds) {
      setSelected([]);
    }
  }, [clearSelecteds]);

  // click in cell table
  //const handleSetActiveItem = useCallback((item) => setActive(item), []);
  const handleSetActiveItem = useCallback((item) => {
    setActive(item)
    handleSubmit(item)
    setSelected((select) => [item]);
  }, []);

  const handlePagination = useCallback((pg) => {
    //setSelected([]);
    setPage(pg);
    onCallbackNewPage(pg);
  }, [data]);

  const handleChangeSearch = useCallback((value) => {
    setQuery(value);
  }, []);


  useEffect(() => {
    if (totalPages < page) {
      setPage(totalPages || 1);
    }
  }, [data, page, totalPages]);


  const handleSubmit = useCallback((item) => {
    !isEmpty(item) && onCallback(item);
    //clearSelecteds = false;
    setSelected([])
  }, [active, data]);


  const handleSubmitRemover = useCallback((e, item) => {
    //clearSelecteds = false;
    !isEmpty(item) && onCallbackRemover(item);
    setSelected([])
    e.stopPropagation();

  }, [active, data]);

  const handleSubmitEdiar = useCallback((item) => {
    //clearSelecteds = false;
    !isEmpty(item) && onCallabackEditar(item);
    setSelected([])
  }, [active, data]);


  const renderHeader = useMemo(
    () =>
      cells.map((cell, index) => (
        <TableCell
          key={`cell-index-head-${index}`}
          align={cell.align || 'left'}
        >
          {cell.label}
        </TableCell>
      )),
    [cells]
  );

  const renderBody = useMemo(
    () =>
      concat([], data)
        .filter((item) =>
          !isEmpty(query)
            ? item[query.column].toString().toUpperCase().indexOf(query.text.toString().toUpperCase()) >
            -1
            : true
        )
        .slice(countPage, delimiter)
        .map((item, index) => (
          <TableRow
            style={{ cursor: 'pointer' }}
            hover
            tabIndex={-1}
            key={`table-row-body-${index}`}
            onClick={() => handleSetActiveItem(item)}
            selected={!!find(selecteds, (select) => select === item)}
          >

            {cells.map((cell, indexKey) => (


              <TableCell
                key={`table-cell-body-${indexKey}`}
                align={cell.align || 'left'}
              >
                {!isUndefined(cell.rule) && cell.rule(item) ? (
                  <input
                    id={`input-${cell.id}-${index}`}
                    type="number"
                    defaultValue={item[cell.id]}
                    onKeyUp={({ target, key }) =>
                      key === 'Enter' &&
                      cell.callback(target.value, index, item)
                    }
                    onBlur={({ target }) =>
                      cell.callback(target.value, index, item)
                    }
                  />
                ) : (
                    cell.format ? cell.format(item[cell.id]) : item[cell.id]
                  )}
              </TableCell>
            ))}

            {onCallabackEditar && <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => handleSubmitEdiar(item)}
            //onClick={() => handleSubmit(item)}
            //onClick={() => console.log(active)}
            >
              {'Editar'}
            </Button>
            }

            {onCallbackRemover && <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={(e) => handleSubmitRemover(e, item)}
            //onClick={() => console.log(active)}
            >
              {'Remover'}
            </Button>
            }

          </TableRow>

        )),
    [
      cells,
      data,
      selecteds,
      paginate,
      countPage,
      delimiter,
      query,
      onCallback,
      onCallbackRemover,
      onCallabackEditar,
      clearSelecteds,
    ]
  );


  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>
        {/* {title} */}
        <Typography>{title}</Typography>
        <S.WrapperSearch>
          {search && <Search options={cells} onSearch={handleChangeSearch} />}
        </S.WrapperSearch>
      </S.WrapperTitle>


      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {/* {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
              <TableCell>
              </TableCell> */}
              {renderHeader}
            </TableRow>
          </TableHead>
          {/* <TableBody>
            {data.map((item, index) => (
              <TableRow
                style={{ cursor: 'pointer' }}
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleSetActiveItem(item)}
                selected={!!find(selecteds, (select) => select === item)}
              >

                {cells.map((cell, indexKey) => (


                  <TableCell
                    key={`table-cell-body-${indexKey}`}
                    align={cell.align || 'left'}
                  >
                    {!isUndefined(cell.rule) && cell.rule(item) ? (
                      <input
                        id={`input-${cell.id}-${index}`}
                        type="number"
                        defaultValue={item[cell.id]}
                        onKeyUp={({ target, key }) =>
                          key === 'Enter' &&
                          cell.callback(target.value, index, item)
                        }
                        onBlur={({ target }) =>
                          cell.callback(target.value, index, item)
                        }
                      />
                    ) : (
                        cell.format ? cell.format(item[cell.id]) : item[cell.id]
                      )}
                  </TableCell>
                ))}

                {onCallabackEditar && <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleSubmitEdiar(item)}
                //onClick={() => handleSubmit(item)}
                //onClick={() => console.log(active)}
                >
                  {'Editar'}
                </Button>
                }

                {onCallbackRemover && <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={(e) => handleSubmitRemover(e, item)}
                //onClick={() => console.log(active)}
                >
                  {'Remover'}
                </Button>
                }

              </TableRow>
            ))}
          </TableBody> */}
          <TableBody>{renderBody}</TableBody>
        </Table>
      </TableContainer>
      <S.Footer>
        <Typography>
          {showCount && (
            <>
              <span>Total:</span> {data.length}
            </>
          )}
        </Typography>

        {!isEmpty(data) && (
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, pg) => handlePagination(pg)}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        )}
      </S.Footer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  onCallback: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCallbackRemover: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCallabackEditar: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCallbackNewPage: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  clearSelecteds: PropTypes.bool,
  paginate: PropTypes.number,
  showCount: PropTypes.bool,
  search: PropTypes.bool,
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  onCallback: false,
  onCallbackRemover: false,
  onCallabackEditar: false,
  onCallbackNewPage: false,
  clearSelecteds: false,
  paginate: 5,
  showCount: false,
  search: false,
};
